import { Box, styled } from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { NavLink } from "react-router-dom";

export default function GeneralNews({ news }) {
  const monthMapping = {
    January: "ינואר",
    February: "פברואר",
    March: "מרץ",
    April: "אפריל",
    May: "מאי",
    June: "יוני",
    July: "יולי",
    August: "אוגוסט",
    September: "ספטמבר",
    October: "אוקטובר",
    November: "נובמבר",
    December: "דצמבר",
  };
  console.log(news);
  const date = new Date(news.created_at);
  const month = monthMapping[date.toLocaleString("en", { month: "long" })];
  const day = date.getDate();
  const year = date.getFullYear();
  const StyledDate = styled(Box)({
    background: "linear-gradient(145deg, #1576CE 0%, #3EA4F5 100%)",
    color: "white",
    width: "72px",
    minWidth: "72px",
    height: "76px",
    textAlign: "center",
    fontFamily: `${process.env.REACT_APP_FONT}`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px",
    borderRadius: "17px",
    boxShadow: "0 9px 20px rgba(31, 125, 201, .2)",
  });
  return (
    <Box
      sx={{
        fontFamily: `${process.env.REACT_APP_FONT}`,
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        p: 1,
        borderRadius: "18px",
        border: "1px solid #E8EFF5",
        backgroundColor: "#FFFFFF",
        transition: "transform .18s ease, box-shadow .18s ease, border-color .18s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 12px 26px rgba(28, 70, 105, .1)",
          borderColor: "#CFE2F2",
        },
      }}
    >
      <StyledDate>
        <Typography
          variant="h5"
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            fontWeight: 800,
            lineHeight: 1,
          }}
        >
          {day}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            fontWeight: 700,
            mt: 0.4,
            lineHeight: 1.15,
          }}
        >
          {month}
          <br />
          {year}
        </Typography>
      </StyledDate>

      <Card
        sx={{
          fontFamily: `${process.env.REACT_APP_FONT}`,
          boxShadow: "none",
          backgroundColor: "transparent",
          minWidth: 0,
          flex: 1,
        }}
      >
        <CardContent
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            p: 0,
            "&:last-child": { pb: 0 },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              color: "#274861",
              fontWeight: 700,
              lineHeight: 1.45,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {news.title.substr(0, 45)}
          </Typography>
        </CardContent>
        <CardActions sx={{ p: 0, pt: 0.5 }}>
          <NavLink
            style={{ textDecoration: "none" }}
            to={`/shownews/${news.id}`}
          >
            <Button
              size="small"
              sx={{
                color: "#1475C9",
                fontFamily: "Assistant",
                fontWeight: 800,
                textTransform: "none",
                minWidth: 0,
                p: 0,
                "&:hover": { backgroundColor: "transparent", color: "#0B5FA9" },
              }}
            >
              למידע נוסף
            </Button>
          </NavLink>
        </CardActions>
      </Card>
    </Box>
  );
}
